import React, { useState } from 'react'
import { useDrag } from 'react-dnd'
import { FormGroup, Label, Button } from 'reactstrap'

import Settings from './Settings'
import { FieldType } from '../../FieldTypes'

const Dropdown = ({
  field,
  removeFunc,
  setFieldOrderFunc,
  updateCurrentSetting,
  setFieldSettingsModalOpen,
  updateFieldSettings
}) => {
  const [isMouseIn, setIsMouseIn] = useState(false)

  // draggable
  const [{ isDragging }, draggable] = useDrag({
    item: { id: field.id, parentId: field.fieldGroupId, type: FieldType.DROPDOWN },
    type: FieldType.DROPDOWN,
    collect: monitor => {
      return {
        isDragging: !!monitor.isDragging()
      }
    }
  })

  return (
    <div
      ref={draggable}
      style={{
        width: '100%',
        border: isMouseIn || isDragging ? '1px dashed black' : 'none',
        cursor: 'move',
        backgroundColor: isDragging ? 'lightblue' : 'white',
        display: 'inline-block'
      }}
    >
      <FormGroup
        onMouseEnter={() => {
          setIsMouseIn(true)
        }}
        onMouseLeave={() => {
          setIsMouseIn(false)
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <Label>
            {field.required ? '* ' : ''}
            {field.displayName}
          </Label>
          <div style={{ display: 'flex' }}>
            <Button
              size='xs'
              color='primary'
              title='Settings'
              onClick={() => {
                updateCurrentSetting(
                  <Settings
                    field={field}
                    setFieldOrderFunc={setFieldOrderFunc}
                    updateFieldSettings={updateFieldSettings}
                  />
                )
                setFieldSettingsModalOpen(true)
              }}
            >
              <i className='fas fa-tools' />
            </Button>
            <Button
              size='xs'
              color='danger'
              title='Remove'
              onClick={() => {
                removeFunc(field.id)
              }}
            >
              <i className='fas fa-times' />
            </Button>
          </div>
        </div>
        <select style={{ width: '100%' }} disabled>
          {field.options.map((o, i) => (
            <option key={i + o.option}>{o.option}</option>
          ))}
        </select>

        <span>{field.instructions}</span>
      </FormGroup>
    </div>
  )
}

export default Dropdown
